/*jshint esversion: 8 */
import React, { Component } from "react";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

import { observer } from "mobx-react";
import { toJS } from "mobx";
import store from "../../../components/stores/Store";
import LocalStore from "./LocalStore";

import TextField from '@material-ui/core/TextField';

import { getIfFuncAuthorized } from "../../../utils/CheckSomething";
import { imgHostIp } from "../../../config/ips";

const styles = {
  root: {},
  textField: {
    width: "15ch",
  },
  formControl: {
    margin: "10px",
    width: "20ch",
    minWidth: "20ch",
  },
  rootform: {
    textAlign: "left",
    marginTop: "10px",
  },
  button: {
    marginLeft: "10px",
    marginTop: "10px",
  },
  hidden: {
    display: "none",
  },
};

class Selection extends Component {
  constructor(props) {
    super(props);
    store.clearTableConfig();
    this.state = {
      deleteConfirmDialogOpen: false,
      importExcelConfirmDialogOpen: false,

      downloadDialogOpen: false,
      downUrl: '',
    };
    // 定制
    this.search = this.props.functions.search;
    this.addRecord = this.props.functions.addRecord;
    this.updateRecord = this.props.functions.updateRecord;
    this.deleteRecords = this.deleteRecords.bind(this);
    this.exportTemplateExcel = this.props.functions.exportTemplateExcel;
    this.importExcel = this.importExcel.bind(this);
    this.doImportExcel = this.doImportExcel.bind(this);

    this.closeConfirmDialog = this.closeConfirmDialog.bind(this);
    this.openDeleteDialog = this.openDeleteDialog.bind(this);
    this.clearSelection = this.clearSelection.bind(this);
    this.exportExcel = this.exportExcel.bind(this);
  }

  componentDidMount() {
    store.setOrderByOfTableConfig('id');
    store.search = this.search;
    this.search();
    store.clearLinesSelected();
  }


  async deleteRecords() {
    this.setState({
      deleteConfirmDialogOpen: false,
    });
    await this.props.functions.deleteRecords();
  }

  closeConfirmDialog() {
    this.setState({
      toDeleteId: '',
      deleteConfirmDialogOpen: false,
    });
  }

  openDeleteDialog(id) {
    this.setState({
      toDeleteId: id,
      deleteConfirmDialogOpen: true,
    });
  }

  clearSelection() {
    const selections = toJS(store.selections);

    const keys = Object.keys(selections);
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];
      store.onChangeSelection({ target: { value: '' }, stopPropagation: () => null }, key);
    }
  }

  async importExcel(e) {
    const rst = await this.props.functions.uploadFile(e);
    if (rst.code === "success" && rst.filename && rst.filename.length > 4) {
      this.setState({
        fileName: rst.filename,
        importExcelConfirmDialogOpen: true,
      });
    } else {
      store.openMessageDialogOpen("上传失败，请重新上传");
    }
  }

  async doImportExcel() {
    this.setState({
      importExcelConfirmDialogOpen: false
    });
    const rst = await this.props.functions.importExcel({ fileName: this.state.fileName });
    console.log(`----- rst: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen("上传失败，请重新上传");
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(
        (rst.msg + JSON.stringify(rst.checkErrorList))
        || "导入成功");
      store.search();
    }
  }

  async exportExcel() {
    const rst = await this.props.functions.exportExcel();
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "导出Excel错误");
    } else if (rst.code === "success") {
      this.setState({
        downloadDialogOpen: true,
        downUrl: `${imgHostIp}/` + (rst.fileName || '')
      });
    }
  }


  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form className={classes.rootform} noValidate autoComplete="off">
          {
            LocalStore.tableFields.map((row) => {
              if (!row.canSearch) return null;
              if (!row.display) return null;
              return (
                <TextField
                  key={row.sid}
                  margin="dense"
                  id={row.sid}
                  label={row.label}
                  variant="standard"

                  value={store.selections[row.sid] || ''}
                  onChange={e => store.onChangeSelection(e, row.sid)}
                  type="text"
                />
              );
            })
          }


          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-查找')) && (
            <Button
              key='search'
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
              className={classes.button}
              onClick={this.search}
            >
              搜索
            </Button>
          )}


          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-查找')) && (
            <Button
              key='clearSelection'
              color="primary"
              variant="contained"
              aria-label="清除搜索"
              className={classes.button}
              onClick={() => this.clearSelection()}
            >
              清除搜索
            </Button>
          )}
        </form>

        <form className={classes.rootform} autoComplete="off">

          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-添加')) && (
            <Button
              key='switchAddDialog'
              color="primary"
              variant="contained"
              aria-label="添加记录"
              className={classes.button}
              onClick={() => LocalStore.switchAddDialog()}
            >
              添加
            </Button>
          )}

          {/* {true && (
            <Button
              key='updateRecord'
              color="primary"
              variant="contained"
              aria-label="deleteRecord"
              className={classes.button}
              onClick={this.updateRecord}
            >
              修改选中（单行）
            </Button>
          )} */}

          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-删除')) && (
            <Button
              key='deleteRecord'
              color="primary"
              variant="contained"
              aria-label="删除记录"
              className={classes.button}
              onClick={() => this.setState({
                deleteConfirmDialogOpen: true,
              })}
              disabled={store.linesSelected.length === 0}
            >
              删除选中
            </Button>
          )}

          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-查找')) && (
            <Button
              key='exportTemplateExcel'
              color="primary"
              variant="contained"
              aria-label="下载模板"
              onClick={() => this.exportTemplateExcel()}
              className={classes.button}
            >
              下载模板
            </Button>
          )}

          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-导出Excel')) && (
            <Button
              key='exportExcel'
              color="primary"
              variant="contained"
              aria-label="导出Excel"
              onClick={() => this.exportExcel()}
              className={classes.button}
            >
              导出Excel
            </Button>
          )}

          <input
            accept="xls/*"
            className={classes.hidden}
            id="contained-button-file"
            onChange={(e) => this.importExcel(e)}
            type="file"
          />

          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-导入Excel')) && (
            <label htmlFor="contained-button-file">
              <Button
                key='importExcel'
                color="primary"
                variant="contained"
                component="span"
                aria-label="导入Excel"
                className={classes.button}
              >
                导入Excel
              </Button>
            </label>
          )}

          {(getIfFuncAuthorized('安居房管理-安置房住户明细表-查找')) && (
            <Button
              key='switchFilterDialog'
              color="primary" variant="contained"
              aria-label="筛选字段"
              className={classes.button}
              onClick={(e) => LocalStore.switchFilterDialog()}
            >
              筛选字段
            </Button>
          )}

        </form>

        <Dialog
          open={this.state.deleteConfirmDialogOpen}
          onClose={this.closeConfirmDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ width: '400px' }}>
            {"确认删除？"}
          </DialogTitle>
          <DialogActions>
            <Button
              color="secondary"
              onClick={() => this.deleteRecords()}
            >
              确认删除
            </Button>
            <Button onClick={this.closeConfirmDialog} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={this.state.importExcelConfirmDialogOpen}
          onClose={() => this.setState({ importExcelConfirmDialogOpen: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ width: '400px' }}>
            确认上传Excel？
          </DialogTitle>
          <DialogActions>
            <Button
              color="secondary"
              onClick={() => this.doImportExcel()}
            >
              确认上传Excel
            </Button>
            <Button onClick={() => this.setState({ importExcelConfirmDialogOpen: false })} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.downloadDialogOpen}
          onClose={() => this.setState({ downloadDialogOpen: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ width: '400px' }}>
            下载Excel
          </DialogTitle>
          <DialogActions>
            <Button
              color="secondary"
              href={this.state.downUrl}
            >
              点击下载
            </Button>
            <Button onClick={() => this.setState({ downloadDialogOpen: false })} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const SelectionObservered = observer(Selection);

SelectionObservered.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectionObservered);
